import responseErrorMessage from '../../../utils/responseErrorMessage';
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { replace } from 'react-router-redux';
import { Trans, withTranslation } from 'react-i18next';
import moment from 'moment-timezone';
import clone from 'clone';
import {
  Button,
  Dimmer,
  Divider,
  Dropdown,
  Form,
  Grid,
  Header,
  Icon,
  Label,
  Loader,
  Message,
  Segment,
} from 'semantic-ui-react';
import { required, numericRange } from '@mhub/web-validations';

import config from '../../../../config';
import fileSize from '../../../utils/fileSize';
import { isForeignCompany } from '../../../utils/companies';
import { fetchM } from '../../../actions/fetchM';
import { flashSuccessMessage, flashErrorMessage } from '../../../actions/flash';
import { canForceReleaseUnitHold, preReservedURL, unitHolderName } from '../../../utils/unitHold';

import {
  UNIT_STATUSES_HQ_ALL,
  UNIT_STATUSES_DE_ALL,
  UNIT_STATUSES_HQ_DEVELOPER,
  UNIT_STATUSES_SIMPLE_MODE,
} from '../../../constants/unitStatuses';
import { namespaces, TRANSLATION_FILES } from '../../../constants/translation';
import { PROPERTY_CATEGORY_HIGH_RISE } from '../../../constants/propertyCategories';

import LoanAmount from '../../../components/LoanAmount';
import EditableBox from '../../../components/EditableBox';
import AppForm from '../../../components/AppForm';
import SpecificationTable from '../../../components/SpecificationTable';
import Timestamp from '../../../components/Timestamp';
import GalleryList from '../../../components/GalleryList';
import MarkdownText from '../../../components/MarkdownText';
import SizeSuffix from '../../../components/SizeSuffix';
import CurrencySymbol from '../../../components/CurrencySymbol';
import { ProjectUnitPackagePricing } from '../../../components/ProjectUnitPackagePricing';
import { ProjectUnitPackageFee } from '../../../components/ProjectUnitPackageFee';
import ProjectUnitPricingTierEdit, { ProjectUnitPricingTierView } from '../../../components/ProjectUnitPricingTier';
import ViewLarge from '../../modals/ViewLarge';
import { fullToAmount, spaFullNumber } from '../../../utils/amount';
import { decodeSearch, encodeSearch } from '../../../utils/url';
import { getItem } from '../../../utils/storage';
import CustomFieldForm from '../../../components/CustomFieldForm';
import PaymentPlanForm from '../../../components/PaymentPlan/PaymentPlanForm';
import MortgageCalculator from '../../../components/MortgageCalculator';
import DelistReasonModal from '../../../components/DelistReasonModal';
import { hasAnyRequiredRoleIDs, matchGroupIDToSrRoleID } from '../../../constants/srRoleAccess';
import { getAreaModelLabel, getLandAreaModelLabel } from '../../../utils/areaLabel';
import {
  hasVietnamElevatedAccess,
  hidesPricesFromAgency,
  isVietnamCompany,
  isVietnamExternalAgent,
  vnUnitTextValues,
} from '../../../utils/vietnam';
import {
  ALL_AGENCIES_VALUE,
  agencyAllocationOptions,
  resolveAgencyAllocationChange,
} from '../../../utils/agencyAllocation';

const styles = {
  divider: { margin: '0.5em 0' },
};

export class Info extends Component {
  static propTypes = {
    token: PropTypes.string,
    id: PropTypes.string,
    unitID: PropTypes.string,
    appConfig: PropTypes.shape({
      data: PropTypes.shape({
        settings: PropTypes.shape({
          allowUnitSocialShare: PropTypes.bool,
          virtualAccountIsEnabled: PropTypes.bool,
          himsIsEnabled: PropTypes.bool,
        }),
      }),
    }),
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
    }),
    auth: PropTypes.shape({
      isDeveloper: PropTypes.bool,
      isSiteplan: PropTypes.bool,
      isBranchLeader: PropTypes.bool,
      isBranchLeaderSupervisorII: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
      isAdminBasic: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
      allowEditUnitPrice: PropTypes.bool,
      allowEditUnitDetails: PropTypes.bool,
      company: PropTypes.object,
    }),
    onCheck: PropTypes.func,
    data: PropTypes.shape({
      project: PropTypes.shape({
        maOwnerCompanyBranchID: PropTypes.number,
      }),
    }),
    packagePricingCalculation: PropTypes.oneOfType([PropTypes.array]),
    calculatedFeePackages: PropTypes.oneOfType([PropTypes.array]),
    newFetch: PropTypes.func,
    isMobile: PropTypes.bool,
    t: PropTypes.func,
    hasPreviewPriceAccess: PropTypes.bool,
    hasGenerateQuotationAccess: PropTypes.bool,
    onToggleQuotationPreview: PropTypes.func,
    showQuotationOpts: PropTypes.bool,
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  static mapStateToProps = state => ({
    appConfig: state.appConfig,
    auth: state.auth,
  })
  static getPropsToState = (props) => {
    const data = props.data || {};
    const packagePricingCalculation = props.packagePricingCalculation || [];
    const calculatedFeePackages = props.calculatedFeePackages || [];
    const editData = JSON.parse(JSON.stringify(data));
    const loading = props.loading;
    const unitCustomFieldSettings = props.unitCustomFieldSettings || [];
    const galleryIsTab = window.innerWidth > 425;
    const showQuotationOpts = props.showQuotationOpts || false;
    data.spaAmount = spaFullNumber(data) || data.spaValue; // decimal amount
    let globalSettings = {};
    const storeGloablSettings = getItem(`${config.get('appName')}.globalSettings`);
    if (storeGloablSettings) {
      try {
        globalSettings = JSON.parse(storeGloablSettings).data || [];
      } catch (e) {
        Bugsnag.notifyException(e);
      }
    }
    return {
      data,
      packagePricingCalculation,
      calculatedFeePackages,
      editData,
      galleryIsTab,
      loading,
      oriData: clone(data),
      unitCustomFieldSettings,
      globalSettings,
      showQuotationOpts,
    };
  }
  constructor(props) {
    super(props);
    const state = Info.getPropsToState(props);
    this.state = {
      ...state,
      collapseSegments: [{
        hideDocument: false,
        hideGallery: false,
        hidePricingPackage: false,
        hidePaymentSchedule: false,
        hideAdditionalFees: false,
        hideMortgageCalculator: false,
      }],
      edit: false,
      editTier: false,
      pictures: [],
      unitLayouts: [],
      errMessages: [],
      showLarge: false,
      selectedPicture: null,
      hasChanges: false,
      delistReasons: [],
      showDelistModal: false,
      selectedDelistReason: '',
    };
    this.validation = {
      reference: createRef(),
      statusID: createRef(),
      projectUnitLayoutID: createRef(),
      size: createRef(),
      landArea: createRef(),
      position: createRef(),
      colSpan: createRef(),
      hsd: createRef(),
      ptd: createRef(),
      geran: createRef(),
      lot: createRef(),
      referenceCode: createRef(),
      zoneOrBlock: createRef(),
      streetNumberOrLevel: createRef(),
      streetOrFacing: createRef(),
      spaAmount: createRef(),
      unitLayoutNew: createRef(),
      view: createRef(),
      vatPercentage: createRef(),
      landValue: createRef(),
      virtualTourURL: createRef(),
      companyBranchAllocationIDs: createRef(),
    };
    this.customFieldValidation = {};
  }
  componentDidMount() {
    window.addEventListener('resize', this.handleResize, false);
    this.fetchCompanyBranches();
    this.fetchDelistReasons();
  }
  componentWillReceiveProps(nextProps) {
    const state = Info.getPropsToState(nextProps);
    if (state.data.projectUnitCustomFields) {
      // setup existing custom fields values in data state
      state.data.projectUnitCustomFields.forEach((d) => {
        state.data[this.ucfPrefix(d.projectUnitCustomFieldSetting.name)] = d.value;
        state.data[`${this.ucfPrefix(d.projectUnitCustomFieldSetting.name)}ID`] = d.id;
        if ((d.projectUnitCustomFieldSetting.type === 'dropdown' || d.projectUnitCustomFieldSetting.type === 'dropdown_multi')) {
          state.data[`${this.ucfPrefix(d.projectUnitCustomFieldSetting.name)}OptionID`] = d.projectUnitCustomFieldSettingOptionID;
          state.data[`${this.ucfPrefix(d.projectUnitCustomFieldSetting.name)}OptionIDs`] = d.projectUnitCustomFieldSettingOptionIDs;
        } else {
          state.data[`${this.ucfPrefix(d.projectUnitCustomFieldSetting.name)}OptionID`] = '';
          state.data[`${this.ucfPrefix(d.projectUnitCustomFieldSetting.name)}OptionIDs`] = [];
        }
      });
    }
    if (state.unitCustomFieldSettings) {
      // setup new custom fields blank values in data state
      state.unitCustomFieldSettings.forEach((d) => {
        if (!state.data[this.ucfPrefix(d.name)]) {
          if (!state.data[`${this.ucfPrefix(d.name)}ID`]) {
            state.data[this.ucfPrefix(d.name)] = d.defaultValue;
          }
          if ((d.type === 'dropdown' || d.type === 'dropdown_multi')) {
            state.data[`${this.ucfPrefix(d.name)}OptionID`] = '';
            state.data[`${this.ucfPrefix(d.name)}OptionIDs`] = [];
          }
        }
      });
    }
    this.setState({ ...state });
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize, false);
  }
  setComponentState(state = {}, callback) {
    return new Promise((res) => {
      this.setState(state, () => {
        if (callback) {
          callback();
        }
        res(state);
      });
    });
  }
  getProjectTiers = () => {
    if (this.state.data.project &&
      this.state.data.project.projectPricings &&
      this.state.data.project.projectPricings.length > 0
    ) {
      return this.state.data.project.projectPricings;
    }
    return [];
  }
  getProjectUnitTiers = () => {
    if (this.state.data.projectUnitPricings &&
      this.state.data.projectUnitPricings.length > 0
    ) {
      return this.state.data.projectUnitPricings;
    }
    return [];
  }
  getProjectPackagePricings = () => {
    if (this.state.data.project && this.state.data.project.projectPackagePricings &&
      this.state.data.project.projectPackagePricings.length > 0
    ) {
      return this.state.data.project.projectPackagePricings;
    }
    return [];
  }
  getUnitPackagePricings = () => {
    const { projectUnitPackagePricings = [] } = this.state.data || {};
    if (projectUnitPackagePricings && projectUnitPackagePricings.length > 0) {
      return projectUnitPackagePricings;
    }
    return [];
  }
  getProjectFeePackages = () => {
    if (this.state.data.project && this.state.data.project.projectFeePackages &&
      this.state.data.project.projectFeePackages.length > 0
    ) {
      return this.state.data.project.projectFeePackages;
    }
    return [];
  }
  getUnitPackageFees = () => {
    const { projectUnitPackageFees = [] } = this.state.data || {};
    if (projectUnitPackageFees &&
      projectUnitPackageFees.length > 0
    ) {
      return projectUnitPackageFees.filter(p => (p.projectFeePackage && p.projectFeePackage.isEnabled) || (p.projectFeePackage && !p.projectFeePackage.id));
    }
    return [];
  }
  getStatusOptions = () => {
    if (this.hasAccess()) {
      return UNIT_STATUSES_HQ_ALL;
    }
    if (this.hasSimpleViewMode()) {
      return UNIT_STATUSES_SIMPLE_MODE;
    }
    return UNIT_STATUSES_DE_ALL;
  }
  getUnitStatus = () => {
    const { oriData } = this.state;
    if (!this.hasAccess() && (oriData.statusID === 'sold_spa_signed' || oriData.statusID === 'developer_sold')) {
      return 'booked';
    }
    return oriData.statusID;
  }
  ucfPrefix = v => `ucf_${v}`
  async fetchCompanyBranches() {
    const { store } = this.context;
    const { t } = this.props;
    let res;
    try {
      res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/projects/${this.props.id}/accessible_company_branches/?isExternal=true`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      let message = t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation });
      if (e && e.res && e.res.status >= 400 && e.res.status < 500) {
        try { message = (await responseErrorMessage(e.res)) || message; } catch (readError) { /* Keep fallback for unreadable responses. */ }
      }
      await store.dispatch(flashErrorMessage({ message }));
      return;
    }
    if (!res.ok) {
      const message = await responseErrorMessage(res);
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const json = await res.json();
      if (json) {
        const data = json.map((obj) => {
          const newResults = {};
          newResults.text = obj.name;
          newResults.value = obj.id;
          return newResults;
        });
        await this.setComponentState({
          companyBranches: data,
        });
      }
    }
  }
  async fetchDelistReasons() {
    const { store } = this.context;
    const { t } = this.props;
    let res;
    try {
      res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/settings/delist_reasons/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      console.error('Error fetching delist reasons:', e);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      console.error('Error fetching delist reasons:', message);
    } else {
      const delistReasons = await res.json();
      await this.setComponentState({
        delistReasons: delistReasons || [],
      });
    }
  }
  handleDelistReasonChange = (value) => {
    this.setState({ selectedDelistReason: value });
  }
  handleDelistModalConfirm = () => {
    const { data, selectedDelistReason } = this.state;

    // Update the unit with the delist reason
    const updatedData = {
      ...data,
      statusID: 'delist',
      delistReasonID: selectedDelistReason || '',
    };

    this.setState({
      data: updatedData,
      showDelistModal: false,
      selectedDelistReason: '',
    }, () => {
      this.handleUpdateUnit();
    });
  }
  handleDelistModalCancel = () => {
    const { oriData } = this.state;

    // Revert the status change
    this.setState({
      showDelistModal: false,
      selectedDelistReason: '',
      data: { ...this.state.data, statusID: oriData.statusID },
    }, () => {
      this.handleResetCheck();
    });
  }
  async fetchProjectUnitLayouts() {
    const { store } = this.context;
    const { t } = this.props;
    let res;
    try {
      res = await store.dispatch(fetchM(`/projects/${this.props.id}/unit_layouts/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const unitLayouts = await res.json();
      // handle token.. etc
      await this.setComponentState({
        unitLayouts: unitLayouts ? unitLayouts.map((ul) => {
          const unitLayout = { text: ul.name, name: ul.id, value: ul.id, size: ul.size };
          return unitLayout;
        }) : [],
      });
    }
  }
  async putUnit(unit, skipValidationCheck = false) {
    const { store } = this.context;
    const { t } = this.props;
    const query = decodeSearch(this.props.location.search);
    if (!skipValidationCheck) {
      const validations = await AppForm.validate({ ...this.validation, ...this.customFieldValidation }, this.state.data);
      const errors = validations.filter(v => !v.isValid);
      if (errors.length > 0) {
        this.setState({ edit: true });
        store.dispatch(flashErrorMessage({ header: 'Please fix form errors', list: errors.map(l => l.message) }));
        return;
      }
    }
    await this.setComponentState({ loading: true });
    let res;
    try {
      res = await store.dispatch(fetchM(`/projects/${this.props.id}/units/${this.props.unitID}/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
        body: JSON.stringify(unit),
      }));
    } catch (err) {
      Bugsnag.notifyException(err);
      await this.setComponentState({ loading: false });
      if (err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage(err));
      return;
    }
    const data = await res.json();
    await this.setComponentState({
      loading: false,
      edit: false,
      editTier: false,
    }, () => {
      this.handleResetCheck();
    });
    this.props.newFetch();
    store.dispatch(replace(`/projects/${this.props.id}/units/${this.props.unitID}/?${encodeSearch(query)}`));
    store.dispatch(flashSuccessMessage({
      header: t('Update Success', { ns: TRANSLATION_FILES.translation }),
      message: t('Unit {{reference}} is successfully updated', { reference: data.reference, ns: TRANSLATION_FILES.translation }),
    }));
  }
  async deleteUnitPricingTier(id) {
    await this.setComponentState({ loading: true });
    const { store } = this.context;
    const { data } = this.state;
    const { t } = this.props;
    const newprojectUnitPricings = data.projectUnitPricings.filter(d => d.id !== id);
    const item = data.projectUnitPricings.find(d => d.id === id);
    try {
      await store.dispatch(fetchM(`/projects/${data.project.id}/units/${data.id}/pricings/${id}/`, {
        credentials: 'include',
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
      }));
    } catch (err) {
      await this.setComponentState({ loading: false });
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: t('There was an error with your request. Please try again.', { ns: TRANSLATION_FILES.translation }) }));
      return;
    }
    await this.setComponentState({ loading: false });
    store.dispatch(flashSuccessMessage({
      header: t('Pricing Deleted', { ns: TRANSLATION_FILES.translation }),
      message: t('{{pricing}} was successfully removed', { pricing: item.projectPricing.name, ns: TRANSLATION_FILES.translation }),
    }));
    data.projectUnitPricings = newprojectUnitPricings;
    await this.setComponentState({ data }, () => {
      this.handleCheckChanges();
      this.props.newFetch();
    });
  }
  handleOnCheck = (hasChanges = false) => {
    if (this.props.onCheck) {
      this.props.onCheck(hasChanges);
    }
  }
  handleCheckChanges() {
    if (!this.state.hasChanges) {
      this.setState({ hasChanges: true }, () => {
        this.handleOnCheck(true);
      });
    }
  }
  handleResetCheck() {
    if (this.state.hasChanges) {
      this.setState({ hasChanges: false }, () => {
        this.handleOnCheck(false);
      });
    }
  }
  handleResize = () => {
    const galleryIsTab = window.innerWidth > 425;
    if (galleryIsTab !== this.state.galleryIsTab) {
      this.setState({ galleryIsTab });
    }
  };
  handleUpdateUnit = () => {
    const { data, oriData, unitCustomFieldSettings } = this.state;
    if (data.projectUnitPricings && data.projectUnitPricings.length > 0) {
      data.projectUnitPricings = data.projectUnitPricings.filter(d => d.projectPricingID !== '');
    }
    const customFields = [];
    if (data.projectUnitCustomFields) {
      data.projectUnitCustomFields.forEach((d) => {
        const customField = {
          id: d.id,
          value: data[this.ucfPrefix(d.projectUnitCustomFieldSetting.name)],
          projectUnitCustomFieldSettingID: d.projectUnitCustomFieldSettingID,
          projectUnitCustomFieldSetting: d.projectUnitCustomFieldSetting,
          projectUnitCustomFieldSettingOptionID: data[`${this.ucfPrefix(d.projectUnitCustomFieldSetting.name)}OptionID`],
          projectUnitCustomFieldSettingOptions: d.projectUnitCustomFieldSettingOptions,
          projectUnitCustomFieldSettingOptionIDs: data[`${this.ucfPrefix(d.projectUnitCustomFieldSetting.name)}OptionIDs`],
        };
        customFields.push(customField);
      });
    }
    if (unitCustomFieldSettings) {
      unitCustomFieldSettings.forEach((d) => {
        let exists = -1;
        if (data.projectUnitCustomFields) exists = data.projectUnitCustomFields.findIndex(ucfData => ucfData.projectUnitCustomFieldSetting.id === d.id);
        if (exists === -1) {
          const customField = {
            value: data[this.ucfPrefix(d.name)],
            projectUnitCustomFieldSettingID: d.id,
            projectUnitCustomFieldSetting: d,
            projectUnitCustomFieldSettingOptionID: data[`${this.ucfPrefix(d.name)}OptionID`],
            projectUnitCustomFieldSettingOptions: d.projectUnitCustomFieldSettingOptions,
            projectUnitCustomFieldSettingOptionIDs: data[`${this.ucfPrefix(d.name)}OptionIDs`],
          };
          customFields.push(customField);
        }
      });
    }
    if (JSON.stringify(data) !== JSON.stringify(oriData)) {
      let unit = Object.assign(data, {
        spaValue: parseFloat(data.spaAmount), // decimal amount
        size: parseFloat(data.size),
        landArea: parseFloat(data.landArea),
        position: parseInt(data.position, 10),
        colSpan: parseInt(data.colSpan, 10),
        // CPI-1230 (D4): stored, never calculated. Only Vietnam sends the two keys.
        ...(isVietnamCompany(this.props.auth) ? {
          vatPercentage: parseFloat(data.vatPercentage) || 0,
          landValue: parseFloat(data.landValue) || 0,
        } : {}),
        // CPI-1219: the unit's own Unit Layout and View, free text and Vietnam only.
        ...vnUnitTextValues(data, isVietnamCompany(this.props.auth)),
      });
      unit = fullToAmount(unit, unit.spaAmount); // decimal amount
      unit.projectUnitPricings = unit.projectUnitPricings.map((p) => {
        const newP = p;
        newP.totalPrice = parseFloat(p.totalPrice);
        return newP;
      });
      unit.projectUnitCustomFields = customFields;
      this.putUnit(unit)
      .catch((err) => {
        Bugsnag.notifyException(err);
      });
    } else {
      this.setState({
        edit: false,
        editTier: false,
      }, () => {
        this.handleResetCheck();
      });
    }
  }
  handleEditUnit = () => {
    this.fetchProjectUnitLayouts();
    this.setState({ edit: true });
  }
  handleChange = (event, value) => {
    const { data, oriData } = this.state;
    const nextValue = value.name === 'companyBranchAllocationIDs' && Array.isArray(value.value) ?
      resolveAgencyAllocationChange(value.value, this.state.companyBranches) : value.value;
    data[value.name] = value.name === 'companyBranchAllocationIDs'
      && Array.isArray(nextValue)
      && nextValue.length === 0
      && (!oriData[value.name] || oriData[value.name].length === 0)
      ? oriData[value.name] : nextValue;

    // Check if status is changing to 'delist'
    if (value.name === 'statusID' && value.value === 'delist' && oriData.statusID !== 'delist') {
      // Show delist reason modal
      const newData = { ...data, [value.name]: value.value };
      this.setState({
        data: newData,
        showDelistModal: true,
        selectedDelistReason: '',
      });
      return;
    }

    const newData = { ...data };
    this.setState({ data: newData }, () => {
      this.handleCheckChanges();
    });
  }
  handleResetUnit = () => {
    const { oriData } = this.state;
    this.setState({
      data: clone(oriData),
      edit: false,
    }, () => {
      this.handleResetCheck();
    });
  }
  hasEditAccess(check = false) {
    const user = this.props.auth;
    if (this.props.auth.isSuperAdmin || this.props.auth.isHeadquarters) {
      return true;
    }
    if (this.props.auth.isBranchLeaderSupervisorII && this.props.data &&
      (this.props.data.project.maOwnerCompanyBranchID === user.companyBranch.id)
    ) {
      return true;
    }
    return check;
  }
  hasAccess(check = false) {
    const user = this.props.auth;
    if (this.props.auth.isHeadquarters || this.props.auth.isSuperAdmin) {
      return true;
    }
    if (this.props.auth.isBranchLeader && this.props.data &&
      (this.props.data.project.maOwnerCompanyBranchID === user.companyBranch.id)
    ) {
      return true;
    }
    return check;
  }
  hasAccessInternal() {
    const auth = this.props.auth;
    if (auth && auth.companyBranch && !auth.companyBranch.isExternal) {
      return true;
    }
    return false;
  }
  handleSpecificationsChange = (data) => {
    const { editData } = this.state;
    editData.specifications = data;
    this.setState({ editData }, () => {
      this.handleCheckChanges();
    });
  }
  handleUpdateUnitLayout = () => {
    const { data, editData } = this.state;
    if (editData.specifications) {
      editData.specifications = editData.specifications.filter(d =>
        d.name.length > 0 && d.value.length > 0).map((d, idx) => ({
          ...d,
          position: idx + 1,
        }));
    }
    if (JSON.stringify(editData) !== JSON.stringify(data)) {
      this.putUnit(editData, true);
    }
    data.specifications = editData.specifications;
    this.setState({ data }, () => {
      this.handleResetUnitLayout();
    });
  }
  handleResetUnitLayout = () => {
    const editData = JSON.parse(JSON.stringify(this.state.data));
    this.setState({ editData }, () => {
      this.handleResetCheck();
    });
  }
  statuses = [
    { name: 'new', value: 'new', text: 'Available' },
    ...UNIT_STATUSES_HQ_DEVELOPER,
    { name: 'delist', value: 'delist', text: 'Delist' },
  ];
  checkStatusDropDown = statusID => this.statuses.some(status => status.value === statusID);

  valueArrayToText = (array, arrayValue) => {
    const text = [];
    if (arrayValue && array) {
      arrayValue.forEach((x) => {
        array.find((y) => {
          if (y.value === x) {
            text.push(y.text);
            return y.text;
          }
          return '';
        });
      });
      return text.join('\n');
    }
    return '';
  }
  checkBookable = (statusID, project) => {
    const user = this.props.auth;
    switch (statusID) {
      case 'new':
      case 'reserved':
        return true;
      case 'delist':
        if (project && project.rduIsEnabled && project.rduAccessGroupIDs) {
          if (user.isAdminBasic || user.isAdmin) return true;

          const uGroupIDs = [...user.groups.map(obj => obj.id)];
          const uSrRoleIDs = matchGroupIDToSrRoleID(uGroupIDs, user.companyBranch.isExternal);
          return hasAnyRequiredRoleIDs(project.rduAccessGroupIDs, uSrRoleIDs);
        }
        return false;
      default:
        return false;
    }
  }
  handleCloseLarge = (e) => {
    e.preventDefault();
    this.setState({
      showLarge: false,
      selectedPicture: null,
    });
  }
  handleViewLarge = (e, data) => {
    e.preventDefault();
    this.setState({
      selectedPicture: data,
      showLarge: true,
    });
  }
  handleGetPicture = (pictures) => {
    this.setState({ pictures });
  }
  handleSlidePicture = (e, direction = 'right') => {
    const { pictures, selectedPicture } = this.state;
    const index = pictures.indexOf(selectedPicture);
    const nextIndex = direction === 'left' ? index - 1 : index + 1;
    this.setState({
      selectedPicture: pictures[nextIndex],
    });
  }
  handleCheckBoxChange = (event, d) => {
    const { data } = this.state;
    data[d.name] = !data[d.name];
    this.setState({ data }, () => {
      this.handleCheckChanges();
    });
  }
  checkDisabled(direction = 'right') {
    const { pictures, selectedPicture } = this.state;
    if (selectedPicture) {
      const index = pictures.indexOf(selectedPicture);
      if (direction === 'left') {
        return index - 1 > 0;
      }
      return index + 1 < pictures.length;
    }
    return false;
  }
  checkUnitSpecificationAccess = (data) => {
    if ((!this.hasAccess() && data.specifications && data.specifications.length < 1) ||
      (!this.hasAccess() && !data.specifications)
    ) {
      return false;
    }
    return true;
  }
  // CPI-1377: HQ (and the platform admins) can release a hold another user has on this unit.
  // book-api refuses everyone else, so the button is only shown to those roles.
  handleForceReleaseHold = async (e) => {
    e.preventDefault();
    const { store } = this.context;
    const { t } = this.props;
    const { data } = this.state;
    await this.setComponentState({ loading: true });
    try {
      await store.dispatch(fetchM(preReservedURL(config.get('bookApiURL'), this.props.id, this.props.unitID, { clear: true }), {
        credentials: 'include',
        method: 'GET',
        ignoreForbidden: true,
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      await this.setComponentState({ loading: false });
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        store.dispatch(flashErrorMessage({ message: await err.res.text() }));
        return;
      }
      store.dispatch(flashErrorMessage({ message: t('There was an error with your request. Please try again.', { ns: TRANSLATION_FILES.translation }) }));
      return;
    }
    await this.setComponentState({ loading: false });
    store.dispatch(flashSuccessMessage({
      header: t('Hold released', { ns: TRANSLATION_FILES.translation }),
      message: t('Unit {{reference}} is available again', { reference: data.reference, ns: TRANSLATION_FILES.translation }),
    }));
    if (this.props.newFetch) this.props.newFetch();
  }
  checkLaunchModeTimeout = (data, user) => {
    if (
      data.project &&
      data.project.isLaunchMode &&
      moment().isBefore(moment(data.reservedTimeoutExpireAt)) &&
      data.reservedByAwsUser !== user.awsUsername
    ) {
      return true;
    }
    return false;
  }
  handleOnCollapseSegment = (e, { name, value }) => {
    const { collapseSegments } = this.state;
    e.preventDefault();
    collapseSegments[name] = !value;
    this.setState({ collapseSegments });
  }
  handleEditTier = () => {
    this.setState({ editTier: true });
  }
  handleUnitPricingTierChange = (newData) => {
    const { data } = this.state;
    data.projectUnitPricings = newData;
    this.setState({ data }, () => {
      this.handleCheckChanges();
    });
  }
  handleResetTier = () => {
    const { oriData } = this.state;
    this.setState({
      data: clone(oriData),
      editTier: false,
    }, () => {
      this.handleResetCheck();
    });
  }
  handleUnitPricingTierDelete = (id) => {
    this.deleteUnitPricingTier(id);
  }
  hasSimpleViewMode = () => {
    const { data } = this.state;
    const user = this.props.auth;
    if (!user.isHeadquarters && !user.isSuperAdmin && !user.isBranchLeader) {
      return data && data.project && data.project.siteplanSettings && (data.project.siteplanSettings.salesChartSimpleMode || data.project.siteplanSettings.siteplanSimpleMode);
    }
    return false;
  }
  handleCustomSelectChange = (e, d, customFieldOptions, cValidation) => {
    const { data } = this.state;
    if (Array.isArray(d.value)) {
      const ids = [];
      const values = [];
      customFieldOptions.forEach((cfo) => {
        d.value.forEach((v) => {
          if (v === cfo.value) {
            ids.push(cfo.id);
            values.push(cfo.value);
          }
        });
      });
      data[`${d.name}OptionIDs`] = ids;
      data[`${d.name}OptionID`] = '';
      data[d.name] = values.join(',');
    } else {
      data[d.name] = d.value;
      const selectedOption = customFieldOptions.find(cfoData => cfoData.value === d.value);
      data[`${d.name}OptionID`] = selectedOption ? selectedOption.id : '';
      data[`${d.name}OptionIDs`] = [];
    }
    this.customFieldValidation = cValidation;
    this.setState({ data }, () => {
      this.handleCheckChanges();
    });
  }
  handleCustomInputChange = (e, cValidation) => {
    const { data } = this.state;
    data[e.target.name] = e.target.value;
    this.customFieldValidation = cValidation;
    this.setState({ data }, () => {
      this.handleCheckChanges();
    });
  }
  hasProjectHimsEnabled = (data) => {
    const { appConfig } = this.props;
    const companyHimsIsEnabled = appConfig && appConfig.data && appConfig.data.himsIsEnabled;
    return companyHimsIsEnabled && data.project && data.project.himsIsEnabled;
  }
  hasHimsStrataEnabled = (data) => {
    const { auth } = this.props;
    if (data.project && data.project.himsStrataIsEnabled === 'no') {
      return false;
    }
    return !((auth.companyBranch && auth.companyBranch.isExternal) && (data.project && data.project.himsStrataIsEnabled === 'yes' && data.project.himsStrataIsHidden));
  }
  checkSizeSuffix = () => {
    const { t } = this.props;
    const { data } = this.state;
    const suffix = data.project && data.project.sizeSuffix;
    switch (suffix) {
      case 'square_metres':
        return isVietnamCompany(this.props.auth) ? ' m²' : ` ${t('sqm', { ns: TRANSLATION_FILES.screens })}`;
      case 'square_feet':
        return ` ${t('sqft', { ns: TRANSLATION_FILES.screens })}`;
      default:
        return '';
    }
  }
  countActiveBooking = () => {
    const { data } = this.state;
    let activeBookingCount = 0;
    const bookingSummary = data.projectUnitBookingSummary;
    if (bookingSummary) {
      activeBookingCount = bookingSummary.reservedCount + bookingSummary.bookedCount + bookingSummary.soldCount;
    }
    if (data.project && data.project.activeBookingsIncludeWaitlist) {
      activeBookingCount += bookingSummary.cancelledAvailabilityCount;
    }
    return activeBookingCount;
  }
  renderCustomFields(isEditing) {
    const { data, unitCustomFieldSettings } = this.state;
    const { appConfig, auth } = this.props;
    if (data) {
      return (
        <div>
          {isEditing && <Divider />}
          <CustomFieldForm
            componentData={data}
            customFieldSettings={unitCustomFieldSettings}
            countryCode={auth && auth.company ? auth.company.countryCode : ''}
            isEditing={isEditing}
            isBookingCustomField={false}
            onCustomInputChange={this.handleCustomInputChange}
            onCustomSelectChange={this.handleCustomSelectChange}
            hasProjectHimsEnabled={this.hasProjectHimsEnabled(data)}
            hasHimsStrataEnabled={this.hasHimsStrataEnabled(data)}
            vaIsEnabled={appConfig && appConfig.data && appConfig.data.settings && appConfig.data.settings.virtualAccountIsEnabled}
          />
        </div>
      );
    }
    return '';
  }
  render() {
    const { isMobile, t, onToggleQuotationPreview } = this.props;
    const {
      calculatedFeePackages,
      companyBranches,
      data,
      editData,
      globalSettings,
      oriData,
      packagePricingCalculation,
      showQuotationOpts,
      unitCustomFieldSettings,
    } = this.state;
    const { hideDocument, hideGallery, hidePricingPackage, hidePaymentSchedule, hideAdditionalFees, hideMortgageCalculator } = this.state.collapseSegments;
    const user = this.props.auth;
    const countryCode = user && user.company && user.company.countryCode;
    const isMalaysia = user && user.company && user.company.countryCode.toUpperCase() === 'MY';
    // CPI-1230: the three Vietnam gates this screen reads; all three are false outside Vietnam.
    const isVietnam = isVietnamCompany(user);
    const isVnAgent = isVietnamExternalAgent(user);
    const canEditVnPricing = hasVietnamElevatedAccess(user) && this.props.auth.allowEditUnitPrice;
    // MS-6522: the project's own setting, else the global one, read the same way in every country.
    // On "Allocate to all" an unallocated unit offers the "All Agencies" pseudo-option; on
    // "Allocate to none" it does not, and the developer assigns an agency explicitly.
    const projectAgencyAllocationSetting = data.project && data.project.agencyAllocationAllocateAll;
    const agencyAllocationAllocateAll = typeof projectAgencyAllocationSetting === 'boolean' ?
      projectAgencyAllocationSetting : Boolean(globalSettings && globalSettings.agencyAllocationAllocateAll);
    const agencyAllocationIDs = data.companyBranchAllocationIDs || [];
    const showAllAgencies = agencyAllocationAllocateAll && agencyAllocationIDs.length === 0;
    const agencyOptions = agencyAllocationOptions({
      companyBranches, allocationIDs: agencyAllocationIDs, showAllAgencies, t,
    });
    const agencyValue = showAllAgencies ? [ALL_AGENCIES_VALUE] : agencyAllocationIDs;
    const renderAgencyLabel = item => ({ content: item.text, active: false });
    // CPI-1372: with the project's "Disable Base Selling Price" box ticked, a Vietnamese agency
    // user gets no price rows at all (list price, selling price before / after tax) - removed,
    // not dashed. The pricing-package, fee and mortgage segments below key off spaValue, which
    // book-api zeroes for the same caller, so they fall away with it.
    const hidePrices = hidesPricesFromAgency(user, data.project);
    const isAgencyAllocationLocked = isVietnam &&
      ['reserved', 'booked', 'sold_spa_signed'].includes(oriData.statusID);
    const canViewPrice = !hidePrices &&
      this.hasAccess(!this.hasAccessInternal() && data.statusID !== 'new' ? false : this.checkBookable(data.statusID, data.project));
    const listPrice = parseFloat(data.spaAmount) || 0;
    const vatPercentage = parseFloat(data.vatPercentage) || 0;
    const vatAmount = listPrice * (vatPercentage / 100);
    const sellingPriceBeforeTax = listPrice;
    const sellingPriceAfterTax = sellingPriceBeforeTax + vatAmount;
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column>
            {this.checkLaunchModeTimeout(data, user) &&
              <Message size="mini" style={{ textAlign: 'center', fontWeight: 'bold', overflowWrap: 'break-word' }}>
                <Trans ns={TRANSLATION_FILES.translation}>
                  Unit is currently viewed by {{ user: unitHolderName(data) }}
                </Trans>
                {canForceReleaseUnitHold(user) &&
                  <span>
                    &nbsp;
                    <Button size="mini" compact basic loading={this.state.loading} onClick={this.handleForceReleaseHold}>
                      {t('Release hold', { ns: TRANSLATION_FILES.translation })}
                    </Button>
                  </span>
                }
              </Message>
            }
            <ViewLarge
              open={this.state.showLarge}
              onClose={this.handleCloseLarge}
              picture={this.state.selectedPicture}
              onSlide={this.handleSlidePicture}
              disabledLeft={!this.checkDisabled('left')}
              disabledRight={!this.checkDisabled('right')}
              slideshow
            />
            <EditableBox
              newHeader={t('Unit Information').toUpperCase()}
              isCollapsible
              editable={this.hasEditAccess() && (this.props.auth.allowEditUnitDetails || this.props.auth.allowEditUnitPrice)}
              isEditing={this.state.edit}
              onEdit={this.handleEditUnit}
              loading={this.state.loading}
              onClick={this.handleUpdateUnit}
              onCancel={this.handleResetUnit}
              content={({ isEditing, onConfirm }) => (
                <AppForm
                  onSubmit={onConfirm}
                  error={this.state.errMessages.length > 0}
                  ref={(ref) => { this.form = ref; }}
                >
                  <Dimmer style={{ zIndex: 20 }} active={this.state.loading} inverted>
                    <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
                  </Dimmer>
                  <Grid>
                    <Grid.Row>
                      <Grid.Column mobile={16} tablet={16} computer={16}>
                        <Grid verticalAlign="middle">
                          <Grid.Row>
                            <Grid.Column width={16} textAlign="center">
                              <Header as="h2" textAlign="center">
                                {data.reference}
                                {
                                  data.project && data.projectUnitLayout &&
                                  <Header.Subheader>
                                    {data.project.name}, {data.projectUnitLayout.name}
                                  </Header.Subheader>
                                }
                              </Header>
                              {
                                oriData.status && (
                                  <div style={{ display: 'inline-flex' }}>
                                    <Label
                                      size="large"
                                      className={`white-text ${this.getUnitStatus()}`}
                                      content={t(this.getStatusOptions().find(status =>
                                        status.value === this.getUnitStatus()).text, { ns: TRANSLATION_FILES.constants })}
                                    />
                                    {
                                      oriData.statusID === 'delist' && oriData.delistOnHold && (this.hasAccessInternal() || !this.hasSimpleViewMode(data)) && <p className="unit-info_description-text">On Hold</p>
                                    }
                                  </div>
                                )
                              }
                              {
                                data.project && data.project.activeBookingsInUnits &&
                                <Grid.Column>
                                  <Label
                                    size="large"
                                    style={{ background: 'transparent', border: '1px solid black', marginTop: '10px' }}
                                    content={`${t('Active Bookings')}: ${this.countActiveBooking()}`}
                                  />
                                </Grid.Column>
                              }
                              {
                                oriData.status && this.hasAccess() &&
                                UNIT_STATUSES_HQ_DEVELOPER.some(status =>
                                status.value === oriData.statusID) &&
                                <p>{t('Outside MHub')}</p>
                              }
                            </Grid.Column>
                            <Grid.Column width={16}>
                              <Divider hidden className="tablet-hide" />
                            </Grid.Column>
                          </Grid.Row>
                        </Grid>
                        <Divider hidden className="large-hide small-hide" />
                      </Grid.Column>
                      {
                        (isEditing && this.props.auth.allowEditUnitDetails) ?
                          <Grid.Column mobile={16} tablet={8} computer={8}>
                            <Grid>
                              <Grid.Column textAlign="left" width={6}>
                                <b>{t('Unit Number')}</b>
                              </Grid.Column>
                              <Grid.Column textAlign="right" width={10}>
                                <AppForm.Input
                                  fluid
                                  onChange={this.handleChange}
                                  placeholder={t('Unit Number')}
                                  name="reference"
                                  value={data.reference}
                                  ref={this.validation.reference}
                                  validateLabel={t('Unit Number')}
                                  validation={[required]}
                                />
                              </Grid.Column>
                            </Grid>
                            <Divider style={styles.divider} />
                          </Grid.Column>
                        : null
                      }
                      {
                        (isEditing && this.props.auth.allowEditUnitDetails) ?
                          <Grid.Column mobile={16} tablet={8} computer={8}>
                            <Grid verticalAlign="middle">
                              <Grid.Column textAlign="left" width={6}>
                                <b>{t('Status')}</b>
                              </Grid.Column>
                              <Grid.Column textAlign="right" width={10}>
                                {
                                  this.checkStatusDropDown(data.statusID) ?
                                    <AppForm.Validate
                                      validation={[required]}
                                      validateLabel={t('Status')}
                                      ref={this.validation.statusID}
                                      onChange={this.handleChange}
                                    >
                                      <Form.Select
                                        name="statusID"
                                        search
                                        fluid
                                        value={data.statusID}
                                        options={this.statuses.map(s => ({
                                          ...s,
                                          text: t(s.text, { ns: TRANSLATION_FILES.constants }),
                                        }))}
                                        onChange={this.handleChange}
                                      />
                                    </AppForm.Validate>
                                  :
                                    <AppForm.Input
                                      name="statusID"
                                      disabled
                                      value={data.status ? data.status.name : ''}
                                    />
                                }
                              </Grid.Column>
                            </Grid>
                            <Divider style={styles.divider} />
                          </Grid.Column>
                        : null
                      }
                      <Grid.Column mobile={16} tablet={8} computer={8}>
                        <Grid verticalAlign="middle">
                          <Grid.Column textAlign="left" width={6}>
                            <b>{t('Project')}</b>
                          </Grid.Column>
                          <Grid.Column textAlign="right" width={10}>
                            {
                              (isEditing && this.props.auth.allowEditUnitDetails) ? (
                                <AppForm.Input
                                  fluid
                                  name="projectID"
                                  value={data.project ? data.project.name : ''}
                                  disabled
                                />
                              ) : (
                                <Link to={`/projects/${this.props.id}/`}>
                                  {data.project ? data.project.name : ''}
                                </Link>
                              )
                            }
                          </Grid.Column>
                        </Grid>
                        <Divider style={styles.divider} />
                        <Grid verticalAlign="middle">
                          <Grid.Column textAlign="left" width={6}>
                            <b>{t('Layout Type')}</b>
                          </Grid.Column>
                          <Grid.Column textAlign="right" width={10}>
                            {
                              (isEditing && this.props.auth.allowEditUnitDetails) ? (
                                <AppForm.Validate
                                  validation={[required]}
                                  validateLabel={t('Layout Type')}
                                  ref={this.validation.projectUnitLayoutID}
                                  onChange={this.handleChange}
                                >
                                  <Form.Select
                                    name="projectUnitLayoutID"
                                    search
                                    fluid
                                    text={data.projectUnitLayoutID ? null : t('Select layout type')}
                                    value={data.projectUnitLayoutID}
                                    options={this.state.unitLayouts}
                                    disabled={this.state.unitLayouts.length === 0}
                                    onChange={this.handleChange}
                                  />
                                </AppForm.Validate>
                              ) : data.projectUnitLayout &&
                              <Link
                                to={`/projects/${this.props.id}/layouts/${data.projectUnitLayoutID}/`}
                              >
                                {data.projectUnitLayout.name}
                              </Link>
                            }
                          </Grid.Column>
                        </Grid>
                        {/* CPI-1219: Vietnam-only rows, and the unit's OWN two descriptions. Unit
                            Layout is not the linked layout above, and View is not the layout's View
                            (CPI-1208, still edited on the layout screen) - the product owner asked
                            for both, "2 fields both sides", on 6 September. Free text, and shown to
                            every role: the server does not strip them either. */}
                        {isVietnam && !isVnAgent && <Divider style={styles.divider} />}
                        {isVietnam && !isVnAgent && (
                          <Grid>
                            <Grid.Column textAlign="left" width={6}>
                              <b>{t('Unit Layout')}</b>
                            </Grid.Column>
                            <Grid.Column textAlign="right" width={10}>
                              {
                                (isEditing && this.props.auth.allowEditUnitDetails) ? (
                                  <AppForm.Input
                                    fluid
                                    name="unitLayoutNew"
                                    onChange={this.handleChange}
                                    placeholder="2PN-2WC"
                                    value={data.unitLayoutNew || ''}
                                    ref={this.validation.unitLayoutNew}
                                  />
                                ) : <p>{data.unitLayoutNew || '-'}</p>
                              }
                            </Grid.Column>
                          </Grid>
                        )}
                        <Divider style={styles.divider} />
                        <Grid>
                          <Grid.Column textAlign="left" width={6}>
                            <b>{getAreaModelLabel(t, countryCode)}</b>
                          </Grid.Column>
                          <Grid.Column textAlign="right" width={10}>
                            {
                              (isEditing && this.props.auth.allowEditUnitDetails) ? (
                                <AppForm.Input
                                  fluid
                                  validateLabel={t('Built up Area')}
                                  name="size"
                                  onChange={this.handleChange}
                                  type="number"
                                  placeholder={t('Built up Area')}
                                  step="0.0001"
                                  value={data.size}
                                  ref={this.validation.size}
                                  validation={[required, {
                                    validate: numericRange,
                                    option: {
                                      min: 1,
                                    },
                                  }]}
                                />
                              ) : (
                                <SizeSuffix
                                  size={data.size}
                                  suffix={data.project ? data.project.sizeSuffix : null}
                                  isVietnam={isVietnam}
                                />
                              )
                            }
                          </Grid.Column>
                        </Grid>
                        <Divider style={styles.divider} />
                        <Grid>
                          <Grid.Column textAlign="left" width={6}>
                            <b>{getLandAreaModelLabel(t, countryCode)}</b>
                          </Grid.Column>
                          <Grid.Column textAlign="right" width={10}>
                            {
                              (isEditing && this.props.auth.allowEditUnitDetails) ? (
                                <AppForm.Input
                                  fluid
                                  name="landArea"
                                  onChange={this.handleChange}
                                  type="number"
                                  placeholder={t('Land Area')}
                                  step="0.0001"
                                  value={data.landArea}
                                  ref={this.validation.landArea}
                                />
                              ) : (
                                <SizeSuffix
                                  size={data.landArea}
                                  suffix={data.project ? data.project.sizeSuffix : null}
                                  isVietnam={isVietnam}
                                />
                              )
                            }
                          </Grid.Column>
                        </Grid>
                        {isVietnam && !isVnAgent && <Divider style={styles.divider} />}
                        {isVietnam && !isVnAgent &&
                          <Grid>
                            <Grid.Column textAlign="left" width={6}>
                              <b>{t('View')}</b>
                            </Grid.Column>
                            <Grid.Column textAlign="right" width={10}>
                              {
                                (isEditing && this.props.auth.allowEditUnitDetails) ? (
                                  <AppForm.Input
                                    fluid
                                    name="view"
                                    onChange={this.handleChange}
                                    placeholder="SE"
                                    value={data.view || ''}
                                    ref={this.validation.view}
                                  />
                                ) : <p>{data.view || '-'}</p>
                              }
                            </Grid.Column>
                          </Grid>
                        }
                        { (isEditing && this.props.auth.allowEditUnitDetails) && <Divider style={styles.divider} />}
                        { (isEditing && this.props.auth.allowEditUnitDetails) ?
                          <Grid verticalAlign="middle">
                            <Grid.Column textAlign="left" width={6}>
                              <b>{t('Unit/Position')}</b>
                            </Grid.Column>
                            <Grid.Column textAlign="right" width={10}>
                              <AppForm.Input
                                validateLabel={t('Unit/Position')}
                                name="position"
                                type="number"
                                value={data.position}
                                onChange={this.handleChange}
                                ref={this.validation.position}
                                validation={[{
                                  validate: numericRange,
                                  option: {
                                    min: 1,
                                  },
                                }]}
                              />
                            </Grid.Column>
                          </Grid>
                          : null
                        }
                        { (isEditing && this.props.auth.allowEditUnitDetails) && <Divider style={styles.divider} />}
                        { (isEditing && this.props.auth.allowEditUnitDetails) ?
                          <Grid verticalAlign="middle">
                            <Grid.Column textAlign="left" width={6}>
                              <b>{t('ColSpan')}</b>
                            </Grid.Column>
                            <Grid.Column textAlign="right" width={10}>
                              <AppForm.Input
                                validateLabel={t('ColSpan')}
                                name="colSpan"
                                type="number"
                                value={data.colSpan}
                                onChange={this.handleChange}
                                ref={this.validation.colSpan}
                                validation={[{
                                  validate: numericRange,
                                  option: {
                                    min: 1,
                                  },
                                }]}
                              />
                            </Grid.Column>
                          </Grid>
                          : null
                        }
                        {((data.address && !isEditing) || isEditing) &&
                          <Divider style={styles.divider} />
                        }
                        { ((data.address && !isEditing) || isEditing) &&
                          <Grid>
                            <Grid.Column textAlign="left" width={6}>
                              <b>{t('Address')}</b>
                            </Grid.Column>
                            <Grid.Column textAlign="right" width={10}>
                              {
                                (isEditing && this.props.auth.allowEditUnitDetails) ? (
                                  <Form.TextArea
                                    name="address"
                                    value={data.address}
                                    onChange={this.handleChange}
                                  />
                                ) : <MarkdownText>{data.address || '-'}</MarkdownText>
                              }
                            </Grid.Column>
                          </Grid>
                        }
                        {isMalaysia && (isEditing || data.isBumi) &&
                          <Divider style={styles.divider} />
                        }
                        {
                          isMalaysia && (isEditing && this.props.auth.allowEditUnitDetails) &&
                            <Grid>
                              <Grid.Column textAlign="left" width={6}>
                                <b>{t('Bumiputera')}</b>
                              </Grid.Column>
                              <Grid.Column textAlign="right" width={10}>
                                <Form.Group>
                                  <Form.Checkbox
                                    label={t('Bumiputera Unit')}
                                    name="isBumi"
                                    checked={this.state.data.isBumi}
                                    onChange={this.handleCheckBoxChange}
                                  />
                                </Form.Group>
                              </Grid.Column>
                            </Grid>
                        }
                        {
                          isMalaysia && (!isEditing || (isEditing && !this.props.auth.allowEditUnitDetails)) && data.isBumi &&
                            <Grid>
                              <Grid.Column textAlign="left" width={6}>
                                <b>{t('Bumiputera')}</b>
                              </Grid.Column>
                              <Grid.Column textAlign="right" width={10}>
                                {t('Yes', { ns: TRANSLATION_FILES.constants })}
                              </Grid.Column>
                            </Grid>
                        }
                        {/* CPI-1230: Vietnam's quota flag is the same is_bumi column under its own
                            label - "Foreign restricted" - so CPI-1210's chart marker keeps reading
                            one field. The pair below mirrors the Malaysian pair above it. */}
                        {isVietnam && !isVnAgent && (isEditing || !isEditing) &&
                          <Divider style={styles.divider} />
                        }
                        {
                          isVietnam && !isVnAgent && (isEditing && this.props.auth.allowEditUnitDetails) &&
                            <Grid>
                              <Grid.Column textAlign="left" width={6}>
                                <b>{t('Foreign restricted')}</b>
                              </Grid.Column>
                              <Grid.Column textAlign="right" width={10}>
                                <Form.Group>
                                  <Form.Checkbox
                                    label={t('Foreign restricted unit')}
                                    name="isBumi"
                                    checked={this.state.data.isBumi}
                                    onChange={this.handleCheckBoxChange}
                                  />
                                </Form.Group>
                              </Grid.Column>
                            </Grid>
                        }
                        {
                          isVietnam && !isVnAgent && (!isEditing || (isEditing && !this.props.auth.allowEditUnitDetails)) &&
                            <Grid>
                              <Grid.Column textAlign="left" width={6}>
                                <b>{t('Foreign restricted')}</b>
                              </Grid.Column>
                              <Grid.Column textAlign="right" width={10}>
                                {data.isBumi ? t('Yes', { ns: TRANSLATION_FILES.constants }) : t('No', { ns: TRANSLATION_FILES.constants })}
                              </Grid.Column>
                            </Grid>
                        }
                        {isMalaysia && (isEditing || data.isTenanted) &&
                          <Divider style={styles.divider} />
                        }
                        {
                          isMalaysia && (isEditing && this.props.auth.allowEditUnitDetails) &&
                            <Grid>
                              <Grid.Column textAlign="left" width={6}>
                                <b>{t('Tenanted')}</b>
                              </Grid.Column>
                              <Grid.Column textAlign="right" width={10}>
                                <Form.Group>
                                  <Form.Checkbox
                                    label={t('Tenanted Unit')}
                                    name="isTenanted"
                                    checked={this.state.data.isTenanted}
                                    onChange={this.handleCheckBoxChange}
                                  />
                                </Form.Group>
                              </Grid.Column>
                            </Grid>
                        }
                        {
                          isMalaysia && (!isEditing || (isEditing && !this.props.auth.allowEditUnitDetails)) && data.isTenanted &&
                            <Grid>
                              <Grid.Column textAlign="left" width={6}>
                                <b>{t('Tenanted')}</b>
                              </Grid.Column>
                              <Grid.Column textAlign="right" width={10}>
                                {t('Yes', { ns: TRANSLATION_FILES.constants })}
                              </Grid.Column>
                            </Grid>
                        }
                        {isMalaysia && (isEditing || data.isMalayReserved) &&
                          <Divider style={styles.divider} />
                        }
                        {
                          isMalaysia && (isEditing && this.props.auth.allowEditUnitDetails) &&
                            <Grid>
                              <Grid.Column textAlign="left" width={6}>
                                <b>{t('Malay Reserved')}</b>
                              </Grid.Column>
                              <Grid.Column textAlign="right" width={10}>
                                <Form.Group>
                                  <Form.Checkbox
                                    label={t('Malay Reserved')}
                                    name="isMalayReserved"
                                    checked={this.state.data.isMalayReserved}
                                    onChange={this.handleCheckBoxChange}
                                  />
                                </Form.Group>
                              </Grid.Column>
                            </Grid>
                        }
                        {
                          isMalaysia && (!isEditing || (isEditing && !this.props.auth.allowEditUnitDetails)) && data.isMalayReserved &&
                            <Grid>
                              <Grid.Column textAlign="left" width={6}>
                                <b>{t('Malay Reserved')}</b>
                              </Grid.Column>
                              <Grid.Column textAlign="right" width={10}>
                                {t('Yes', { ns: TRANSLATION_FILES.constants })}
                              </Grid.Column>
                            </Grid>
                        }
                      </Grid.Column>
                      <Grid.Column mobile={16} tablet={8} computer={8}>
                        { !isVietnam && ((data.hsd && !isEditing) || isEditing) &&
                          <Grid>
                            <Grid.Column textAlign="left" width={6}>
                              <b>{t('HSD')}</b>
                            </Grid.Column>
                            <Grid.Column textAlign="right" width={10}>
                              {
                                (isEditing && this.props.auth.allowEditUnitDetails) ? (
                                  <AppForm.Input
                                    fluid
                                    name="hsd"
                                    onChange={this.handleChange}
                                    value={data.hsd}
                                    ref={this.validation.hsd}
                                  />
                              ) : <p>{data.hsd || '-'}</p>
                              }
                            </Grid.Column>
                          </Grid>
                        }
                        {!isVietnam && ((data.hsd && !isEditing) || isEditing) &&
                          <Divider style={styles.divider} />
                        }
                        { !isVietnam && ((data.ptd && !isEditing) || isEditing) &&
                          <Grid>
                            <Grid.Column textAlign="left" width={6}>
                              <b>{t('PTD')}</b>
                            </Grid.Column>
                            <Grid.Column textAlign="right" width={10}>
                              {
                                (isEditing && this.props.auth.allowEditUnitDetails) ? (
                                  <AppForm.Input
                                    fluid
                                    name="ptd"
                                    onChange={this.handleChange}
                                    value={data.ptd}
                                    ref={this.validation.ptd}
                                  />
                              ) : <p>{data.ptd || '-'}</p>
                              }
                            </Grid.Column>
                          </Grid>
                        }
                        {!isVietnam && ((data.ptd && !isEditing) || isEditing) &&
                          <Divider style={styles.divider} />
                        }
                        { !isVietnam && ((data.geran && !isEditing) || isEditing) &&
                          <Grid>
                            <Grid.Column textAlign="left" width={6}>
                              <b>{t('Geran')}</b>
                            </Grid.Column>
                            <Grid.Column textAlign="right" width={10}>
                              {
                                (isEditing && this.props.auth.allowEditUnitDetails) ? (
                                  <AppForm.Input
                                    fluid
                                    name="geran"
                                    onChange={this.handleChange}
                                    value={data.geran}
                                    ref={this.validation.geran}
                                  />
                              ) : <p>{data.geran || '-'}</p>
                              }
                            </Grid.Column>
                          </Grid>
                        }
                        {!isVietnam && ((data.geran && !isEditing) || isEditing) &&
                          <Divider style={styles.divider} />
                        }
                        { !isVietnam && ((data.lot && !isEditing) || isEditing) &&
                          <Grid>
                            <Grid.Column textAlign="left" width={6}>
                              <b>{t('Lot')}</b>
                            </Grid.Column>
                            <Grid.Column textAlign="right" width={10}>
                              {
                                (isEditing && this.props.auth.allowEditUnitDetails) ? (
                                  <AppForm.Input
                                    fluid
                                    name="lot"
                                    onChange={this.handleChange}
                                    value={data.lot}
                                    ref={this.validation.lot}
                                  />
                              ) : <p>{data.lot || '-'}</p>
                              }
                            </Grid.Column>
                          </Grid>
                        }
                        {!isVietnam && !isVnAgent && ((data.lot && !isEditing) || isEditing) &&
                          <Divider style={styles.divider} />
                        }
                        { !isVietnam && !isVnAgent && ((data.referenceCode && !isEditing) || isEditing) &&
                          <Grid>
                            <Grid.Column textAlign="left" width={6}>
                              <b>{t('Reference Code')}</b>
                            </Grid.Column>
                            <Grid.Column textAlign="right" width={10}>
                              {
                                (isEditing && this.props.auth.allowEditUnitDetails) ? (
                                  <AppForm.Input
                                    fluid
                                    name="referenceCode"
                                    onChange={this.handleChange}
                                    value={data.referenceCode}
                                    ref={this.validation.referenceCode}
                                  />
                              ) : <p>{data.referenceCode || '-'}</p>
                              }
                            </Grid.Column>
                          </Grid>
                        }
                        { !isVietnam && !isVnAgent && ((data.referenceCode && !isEditing) || isEditing) &&
                          <Divider style={styles.divider} />
                        }
                        { ((data.zoneOrBlock && !isEditing) || isEditing) &&
                        <Grid>
                          <Grid.Column textAlign="left" width={6}>
                            <b>
                              {
                                t(data.project &&
                                data.project.propertyCategory.category === PROPERTY_CATEGORY_HIGH_RISE ?
                                'Block' : 'Zone')
                              }
                            </b>
                          </Grid.Column>
                          <Grid.Column textAlign="right" width={10}>
                            {
                              (isEditing && this.props.auth.allowEditUnitDetails) ? (
                                <AppForm.Input
                                  fluid
                                  name="zoneOrBlock"
                                  onChange={this.handleChange}
                                  value={data.zoneOrBlock}
                                  ref={this.validation.zoneOrBlock}
                                />
                            ) : <p>{data.zoneOrBlock || '-'}</p>
                            }
                          </Grid.Column>
                        </Grid>
                        }
                        {((data.zoneOrBlock && !isEditing) || isEditing) &&
                          <Divider style={styles.divider} />
                        }
                        { ((data.streetNumberOrLevel && !isEditing) || isEditing) &&
                          <Grid>
                            <Grid.Column textAlign="left" width={6}>
                              <b>
                                {
                                  t(data.project &&
                                  data.project.propertyCategory.category === PROPERTY_CATEGORY_HIGH_RISE ?
                                  'Level' : 'Street Number')
                                }
                              </b>
                            </Grid.Column>
                            <Grid.Column textAlign="right" width={10}>
                              {
                                (isEditing && this.props.auth.allowEditUnitDetails) ? (
                                  <AppForm.Input
                                    fluid
                                    name="streetNumberOrLevel"
                                    onChange={this.handleChange}
                                    value={data.streetNumberOrLevel}
                                    ref={this.validation.streetNumberOrLevel}
                                  />
                              ) : <p>{data.streetNumberOrLevel || '-'}</p>
                              }
                            </Grid.Column>
                          </Grid>
                        }
                        { !isVnAgent && ((data.streetNumberOrLevel && !isEditing) || isEditing) &&
                          <Divider style={styles.divider} />
                        }
                        { !isVnAgent && ((data.streetOrFacing && !isEditing) || isEditing) &&
                          <Grid>
                            <Grid.Column textAlign="left" width={6}>
                              <b>
                                {
                                  t(data.project &&
                                  data.project.propertyCategory.category === PROPERTY_CATEGORY_HIGH_RISE ?
                                  'Facing' : 'Street')
                                }
                              </b>
                            </Grid.Column>
                            <Grid.Column textAlign="right" width={10}>
                              {
                                (isEditing && this.props.auth.allowEditUnitDetails) ? (
                                  <AppForm.Input
                                    fluid
                                    name="streetOrFacing"
                                    onChange={this.handleChange}
                                    value={data.streetOrFacing}
                                    ref={this.validation.streetOrFacing}
                                  />
                              ) : <p>{data.streetOrFacing || '-'}</p>
                              }
                            </Grid.Column>
                          </Grid>
                        }
                        {isVietnam && !isVnAgent && <Divider style={styles.divider} />}
                        {isVietnam && !isVnAgent &&
                          <Grid>
                            <Grid.Column textAlign="left" width={6}>
                              <b>{t('Land Value')}</b>
                            </Grid.Column>
                            <Grid.Column textAlign="right" width={10}>
                              {
                                (isEditing && canEditVnPricing) ? (
                                  <AppForm.Input
                                    fluid
                                    validateLabel={t('Land Value')}
                                    name="landValue"
                                    onChange={this.handleChange}
                                    type="number"
                                    placeholder={t('Land Value')}
                                    step="0.01"
                                    value={data.landValue}
                                    ref={this.validation.landValue}
                                    validation={[{
                                      validate: numericRange,
                                      option: {
                                        min: 0,
                                      },
                                    }]}
                                  />
                                ) : (data.landValue && data.project ?
                                  <LoanAmount
                                    projectCurrencies={data.project.projectCurrency}
                                    format="0,000,000.00"
                                    amount={data.landValue}
                                    prefix={<CurrencySymbol />}
                                  />
                                  : <p>-</p>)
                              }
                            </Grid.Column>
                          </Grid>
                        }
                        {
                          ((data.streetOrFacing && !isEditing) || isEditing) &&
                          <Divider style={styles.divider} />
                        }
                        {
                          canViewPrice &&
                          <Grid>
                            <Grid.Column textAlign="left" width={6}>
                              <b>
                                {
                                  isVietnam
                                    ? t('List Price')
                                    : (globalSettings && globalSettings.sellingPrice
                                      ? globalSettings.sellingPrice
                                      : t('Selling Price'))
                                }
                              </b>
                            </Grid.Column>
                            <Grid.Column textAlign="right" width={10}>
                              {
                                (isEditing && this.props.auth.allowEditUnitPrice) ?
                                  <AppForm.Input
                                    validateLabel={
                                      isVietnam
                                        ? t('List Price')
                                        : (globalSettings && globalSettings.sellingPrice
                                          ? globalSettings.sellingPrice
                                          : t('Selling Price'))
                                    }
                                    name="spaAmount"
                                    type="number"
                                    step="0.01"
                                    pattern="^\d+(?:\.\d{1,2})?$"
                                    value={data.spaAmount}
                                    onChange={this.handleChange}
                                    ref={this.validation.spaAmount}
                                    validation={[required, {
                                      validate: numericRange,
                                      option: {
                                        min: 1,
                                      },
                                    }]}
                                  />
                                : null
                              }
                              {
                                (!isEditing || !this.props.auth.allowEditUnitPrice) && (data.spaValue ?
                                  <LoanAmount
                                    projectCurrencies={data.project.projectCurrency}
                                    format="0,000,000.00"
                                    amount={data.spaAmount}
                                    prefix={<CurrencySymbol />}
                                  />
                                : '-')
                              }
                            </Grid.Column>
                          </Grid>
                        }
                        {
                          canViewPrice &&
                            <Divider style={{ margin: '0.5em 0' }} />
                        }
                        {/* CPI-1230 (D3): the price-per-area derivation is an internal pricing row,
                            so a Vietnamese external agent does not see it. Malaysia is unchanged. */}
                        {!isVnAgent &&
                        <Grid verticalAlign="middle">
                          <Grid.Column textAlign="left" width={10}>
                            <b>{t('Price')} per {this.checkSizeSuffix()}</b>
                          </Grid.Column>
                          <Grid.Column width={6}>
                            <div style={{ textAlign: 'right' }}>
                              {
                                data.size > 0 ?
                                  <LoanAmount
                                    projectCurrencies={data.project.projectCurrency}
                                    format="0,000,000.00"
                                    amount={(data.spaAmount / data.size).toFixed(2)}
                                    prefix={<CurrencySymbol />}
                                  />
                                  : '-'
                              }
                            </div>
                          </Grid.Column>
                        </Grid>
                        }
                        {/* CPI-1230 (D3/D4): VAT % and Land Value are stored, never calculated.
                          External agents are not shown the raw rows, but VAT % is still sent so
                          the agent-visible before/after-tax prices can be derived. */}
                        {isVietnam && !isVnAgent && <Divider style={styles.divider} />}
                        {isVietnam && !isVnAgent &&
                          <Grid>
                            <Grid.Column textAlign="left" width={6}>
                              <b>{t('VAT %')}</b>
                            </Grid.Column>
                            <Grid.Column textAlign="right" width={10}>
                              {
                                (isEditing && canEditVnPricing) ? (
                                  <AppForm.Input
                                    fluid
                                    validateLabel={t('VAT %')}
                                    name="vatPercentage"
                                    onChange={this.handleChange}
                                    type="number"
                                    placeholder={t('VAT %')}
                                    step="0.001"
                                    value={data.vatPercentage}
                                    ref={this.validation.vatPercentage}
                                    validation={[{
                                      validate: numericRange,
                                      option: {
                                        min: 0,
                                        max: 100,
                                      },
                                    }]}
                                  />
                                ) : <p>{data.vatPercentage ? `${data.vatPercentage}%` : '-'}</p>
                              }
                            </Grid.Column>
                          </Grid>
                        }
                        {canViewPrice && isVietnam && !isVnAgent && <Divider style={styles.divider} />}
                        {canViewPrice && isVietnam && !isVnAgent &&
                          <Grid>
                            <Grid.Column textAlign="left" width={6}>
                              <b>{t('VAT Amount', { ns: TRANSLATION_FILES.translation })}</b>
                            </Grid.Column>
                            <Grid.Column textAlign="right" width={10}>
                              <LoanAmount
                                projectCurrencies={data.project ? data.project.projectCurrency : []}
                                format="0,000,000.00"
                                amount={vatAmount}
                                prefix={<CurrencySymbol />}
                              />
                            </Grid.Column>
                          </Grid>
                        }
                        {canViewPrice && isVietnam && !isVnAgent && <Divider style={styles.divider} />}
                        {canViewPrice && isVietnam &&
                          <Grid>
                            <Grid.Column textAlign="left" width={6}>
                              <b>{t('Selling Price (Before Tax)', { ns: TRANSLATION_FILES.translation })}</b>
                            </Grid.Column>
                            <Grid.Column textAlign="right" width={10}>
                              <LoanAmount
                                projectCurrencies={data.project ? data.project.projectCurrency : []}
                                format="0,000,000.00"
                                amount={sellingPriceBeforeTax}
                                prefix={<CurrencySymbol />}
                              />
                            </Grid.Column>
                          </Grid>
                        }
                        {canViewPrice && isVietnam && <Divider style={styles.divider} />}
                        {canViewPrice && isVietnam &&
                          <Grid>
                            <Grid.Column textAlign="left" width={6}>
                              <b>{t('Selling Price (After Tax)', { ns: TRANSLATION_FILES.translation })}</b>
                            </Grid.Column>
                            <Grid.Column textAlign="right" width={10}>
                              <LoanAmount
                                projectCurrencies={data.project ? data.project.projectCurrency : []}
                                format="0,000,000.00"
                                amount={sellingPriceAfterTax}
                                prefix={<CurrencySymbol />}
                              />
                            </Grid.Column>
                          </Grid>
                        }
                        {
                          data.statusID === 'delist' && data.delistReason && (
                            <React.Fragment>
                              <Divider style={{ margin: '0.5em 0' }} />
                              <Grid verticalAlign="middle">
                                <Grid.Column textAlign="left" width={10}>
                                  <b>{t('Delist Reason')}</b>
                                </Grid.Column>
                                <Grid.Column width={6}>
                                  <div style={{ textAlign: 'right' }}>
                                    {data.delistReason.label || t('No Reason')}
                                  </div>
                                </Grid.Column>
                              </Grid>
                            </React.Fragment>
                          )
                        }
                      </Grid.Column>
                    </Grid.Row>
                    {
                      (data.remarkExternal || data.remarkInternal || isEditing) &&
                      <Grid.Row>
                        <Grid.Column mobile={16} tablet={8} computer={8}>
                          <Divider style={styles.divider} />
                          { ((data.remarkExternal && !isEditing) || isEditing) &&
                            <Grid>
                              <Grid.Column textAlign="left" width={6}>
                                <b>{t('Notes')}</b>
                              </Grid.Column>
                              <Grid.Column textAlign="right" width={10}>
                                {
                                  (isEditing && this.props.auth.allowEditUnitDetails) ? (
                                    <Form.TextArea
                                      name="remarkExternal"
                                      value={data.remarkExternal}
                                      onChange={this.handleChange}
                                    />
                                ) : <MarkdownText>{data.remarkExternal || '-'}</MarkdownText>
                                }
                              </Grid.Column>
                            </Grid>
                          }
                        </Grid.Column>
                        {/* CPI-1230 (D3): the internal staff remark is not sent to a Vietnamese
                            external agent, and is not rendered for one either. */}
                        { !isVnAgent && (data.remarkInternal || isEditing) &&
                          <Grid.Column mobile={16} tablet={8} computer={8}>
                            <Divider style={styles.divider} />
                            <Grid>
                              <Grid.Column textAlign="left" width={6}>
                                <b>{t('Remark for internal staff')}</b>
                              </Grid.Column>
                              <Grid.Column textAlign="right" width={10}>
                                {
                                  (isEditing && this.props.auth.allowEditUnitDetails) ? (
                                    <Form.TextArea
                                      name="remarkInternal"
                                      value={data.remarkInternal}
                                      onChange={this.handleChange}
                                    />
                                ) : <MarkdownText>{data.remarkInternal || '-'}</MarkdownText>
                                }
                              </Grid.Column>
                            </Grid>
                          </Grid.Column>
                        }
                      </Grid.Row>
                    }
                    <Grid.Row>
                      {
                        isEditing && (
                        <Grid.Column mobile={16} tablet={8} computer={8}>
                          <Divider style={styles.divider} />
                          <Grid>
                            <Grid.Column textAlign="left" width={6}>
                              <b>{t('Virtual Tour URL')}</b>
                            </Grid.Column>
                            <Grid.Column textAlign="right" width={10}>
                              <AppForm.Input
                                name="virtualTourURL"
                                value={data.virtualTourURL}
                                placeholder={data.projectUnitLayout ? data.projectUnitLayout.virtualTourURL : ''}
                                onChange={this.handleChange}
                                ref={this.validation.virtualTourURL}
                              />
                            </Grid.Column>
                          </Grid>
                        </Grid.Column>
                        )
                      }
                      {this.hasAccessInternal() && (
                      <Grid.Column mobile={16} tablet={8} computer={8}>
                        <Divider style={styles.divider} />
                        <Grid>
                          <Grid.Column textAlign="left" width={6}>
                            <b>{t('Agency')}</b>
                          </Grid.Column>
                          <Grid.Column textAlign="right" width={10}>
                            {
                              isEditing ? (
                                companyBranches ? (
                                  <div className="agency-allocation-dropdown">
                                    <Dropdown
                                      name="companyBranchAllocationIDs"
                                      onChange={this.handleChange}
                                      placeholder={t('Select Agency')}
                                      fluid
                                      multiple
                                      search
                                      selection
                                      selectOnBlur={false}
                                      renderLabel={renderAgencyLabel}
                                      options={agencyOptions}
                                      value={agencyValue}
                                      disabled={isAgencyAllocationLocked}
                                      ref={this.validation.companyBranchAllocationIDs}
                                    />
                                  </div>
                                ) : ''
                              ) : (
                                <p style={{ whiteSpace: 'pre-line' }}>
                                  {data.companyBranchAllocationIDs ? this.valueArrayToText(companyBranches, data.companyBranchAllocationIDs) : '-'}
                                </p>
                              )
                            }
                          </Grid.Column>
                        </Grid>
                      </Grid.Column>
                      )}
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={16}>
                        {unitCustomFieldSettings && unitCustomFieldSettings.length > 0 ?
                          this.renderCustomFields(isEditing)
                          : ''
                        }
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </AppForm>
              )}
            />
            { !isVietnam && data.spaValue > 0 && data.project && data.project.paymentPlanFlow ? <Divider hidden /> : '' }
            { !isVietnam && data.spaValue > 0 && data.project && data.project.paymentPlanFlow ?
              <Grid.Row>
                <Grid.Column width={16} style={isMobile ? { padding: '0' } : {}}>
                  <Header
                    className="new_title"
                    as="h5"
                    textAlign="center"
                    attached="top"
                  >
                    <Grid>
                      <Grid.Row>
                        <Grid.Column width={16} textAlign="center">
                          {t('Payment Schedule').toUpperCase()}
                        </Grid.Column>
                        <Label
                          as="button"
                          attached="top right"
                          icon={hidePaymentSchedule ? 'angle up' : 'angle down'}
                          className="collapse-button"
                          style={{
                            position: 'absolute',
                            right: '0',
                            top: '3px',
                            marginRight: '0',
                            marginTop: '0.5em',
                          }}
                          name="hidePaymentSchedule"
                          value={hidePaymentSchedule}
                          onClick={this.handleOnCollapseSegment}
                          disabled={this.state.loading}
                        />
                      </Grid.Row>
                    </Grid>
                  </Header>
                  {
                    !hidePaymentSchedule ? (
                      <Segment attached>
                        <PaymentPlanForm
                          bookingData={{
                            projectID: oriData.projectID,
                            project: oriData.project,
                            projectUnitID: oriData.id,
                            spaValue: oriData.spaValue,
                            spaDecimal: oriData.spaDecimal,
                            spaFull: oriData.spaFull,
                            spaTimes: oriData.spaTimes,
                            statusID: 'reserved',
                          }}
                          token={this.props.token}
                        />
                      </Segment>
                    ) : null
                  }
                </Grid.Column>
              </Grid.Row>
              : ''
            }
            { data.spaValue > 0 ? <Divider hidden /> : '' }
            { data.spaValue > 0 ?
              <Grid.Row>
                <Grid.Column width={16} style={isMobile ? { padding: '0' } : {}}>
                  <Header
                    className="new_title"
                    as="h5"
                    textAlign="center"
                    attached="top"
                  >
                    <Grid>
                      <Grid.Row>
                        <Grid.Column id="pricing_package_div" width={16} textAlign="center">
                          {t('Pricing Package').toUpperCase()}
                        </Grid.Column>
                        <Label
                          as="button"
                          attached="top right"
                          icon={hidePricingPackage ? 'angle up' : 'angle down'}
                          className="collapse-button"
                          style={{
                            position: 'absolute',
                            right: '0',
                            top: '3px',
                            marginRight: '0',
                            marginTop: '0.5em',
                          }}
                          name="hidePricingPackage"
                          value={hidePricingPackage}
                          onClick={this.handleOnCollapseSegment}
                          disabled={this.state.loading}
                        />
                      </Grid.Row>
                    </Grid>
                  </Header>
                  {
                    !hidePricingPackage ? (
                      <Segment attached>
                        <ProjectUnitPackagePricing
                          calculatePackagePricing={packagePricingCalculation || []}
                          data={this.getUnitPackagePricings()}
                          hasEditAccess={this.hasEditAccess() && this.props.auth.allowEditUnitPrice}
                          hasPreviewPriceAccess={this.props.hasPreviewPriceAccess}
                          hasGenerateQuotationAccess={this.props.hasGenerateQuotationAccess}
                          isBumiUnit={data.isBumi}
                          newFetch={this.props.newFetch}
                          onToggleQuotationPreview={onToggleQuotationPreview}
                          packagePricings={this.getProjectPackagePricings()}
                          projectCurrencies={data.project.projectCurrency}
                          projectDefaultBFP={data.project.defaultBookingFeeAmount}
                          projectDefaultBumiPackagePricingID={data.project.defaultBumiProjectPackagePricingID}
                          projectDefaultPackagePricingID={data.project.defaultProjectPackagePricingID}
                          projectID={data.project.id || ''}
                          projectName={data.project.name}
                          projectQuatationCode={data.project.quotnProjectCode}
                          showQuotationOpts={showQuotationOpts}
                          spaValue={spaFullNumber(data) || 0}
                          token={this.props.token}
                          unitID={data.id || ''}
                          unitReference={data.reference}
                          isMobile={isMobile}
                        />
                      </Segment>
                    ) : null
                  }
                </Grid.Column>
              </Grid.Row>
              : ''
            }
            { data.spaValue > 0 ? <Divider hidden /> : '' }
            { data.spaValue > 0 ?
              <Grid.Row>
                <Grid.Column width={16} style={isMobile ? { padding: '0' } : {}}>
                  <Header
                    className="new_title"
                    as="h5"
                    textAlign="center"
                    attached="top"
                  >
                    <Grid>
                      <Grid.Row>
                        <Grid.Column width={16} textAlign="center">
                          {t('Additional Fees').toUpperCase()}
                        </Grid.Column>
                        <Label
                          as="button"
                          attached="top right"
                          icon={hideAdditionalFees ? 'angle up' : 'angle down'}
                          className="collapse-button"
                          style={{
                            position: 'absolute',
                            right: '0',
                            top: '3px',
                            marginRight: '0',
                            marginTop: '0.5em',
                          }}
                          name="hideAdditionalFees"
                          value={hideAdditionalFees}
                          onClick={this.handleOnCollapseSegment}
                          disabled={this.state.loading}
                        />
                      </Grid.Row>
                    </Grid>
                  </Header>
                  {
                    !hideAdditionalFees ? (
                      <Segment attached>
                        <ProjectUnitPackageFee
                          data={this.getUnitPackageFees()}
                          hasEditAccess={this.hasEditAccess() && this.props.auth.allowEditUnitPrice}
                          feePackages={this.getProjectFeePackages()}
                          projectCurrencies={data.project.projectCurrency}
                          projectID={data.project.id || ''}
                          spaValue={spaFullNumber(data) || 0}
                          unitID={data.id || ''}
                          newFetch={this.props.newFetch}
                          token={this.props.token}
                          calculateFeePackage={calculatedFeePackages || []}
                          hasPreviewPriceAccess={this.props.hasPreviewPriceAccess}
                        />
                      </Segment>
                    ) : null
                  }
                </Grid.Column>
              </Grid.Row>
              : ''
            }
            { this.hasAccess() && this.props.auth.isAdminBasic && data.spaValue > 0 ? <Divider hidden /> : '' }
            { this.hasAccess() && this.props.auth.isAdminBasic && data.spaValue > 0 ?
              <EditableBox
                newHeader={`${t('Discount Pricing')} (${t('Old')})`.toUpperCase()}
                isCollapsible
                editable={this.hasEditAccess() && this.props.auth.allowEditUnitPrice}
                isEditing={this.state.editTier}
                onEdit={this.handleEditTier}
                loading={this.state.loading}
                onClick={this.handleUpdateUnit}
                onCancel={this.handleResetTier}
                content={({ isEditing }) => (
                  <div>
                    <Dimmer style={{ zIndex: 20 }} active={this.state.loading} inverted>
                      <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
                    </Dimmer>
                    {
                      isEditing ?
                        <Grid>
                          <Grid.Row>
                            <Grid.Column textAlign="center">
                              <ProjectUnitPricingTierEdit
                                data={this.getProjectUnitTiers()}
                                projectTiers={this.getProjectTiers()}
                                onDelete={this.handleUnitPricingTierDelete}
                                onChangeData={this.handleUnitPricingTierChange}
                              />
                            </Grid.Column>
                          </Grid.Row>
                        </Grid>
                      :
                        <ProjectUnitPricingTierView
                          projectCurrencies={data.project.projectCurrency}
                          tiers={this.getProjectUnitTiers()}
                          spaValue={spaFullNumber(data) || 0}
                          sellingPriceCustomName={globalSettings && globalSettings.sellingPrice}
                        />
                    }
                  </div>
                )}
              />
              : ''
            }
            { data.spaValue > 0 && this.props.auth && !isForeignCompany(this.props.auth.company) ? <Divider hidden /> : '' }
            {
              data.spaValue > 0 && this.props.auth && !isForeignCompany(this.props.auth.company) ? (
                <Grid.Row>
                  <Grid.Column width={16} style={isMobile ? { padding: '0' } : {}}>
                    <Header
                      className="new_title"
                      as="h5"
                      textAlign="center"
                      attached="top"
                    >
                      <Grid>
                        <Grid.Row>
                          <Grid.Column width={16} textAlign="center">
                            MORTGAGE CALCULATOR
                          </Grid.Column>
                          <Label
                            as="button"
                            attached="top right"
                            icon={hideMortgageCalculator ? 'angle up' : 'angle down'}
                            className="collapse-button"
                            style={{
                              position: 'absolute',
                              right: '0',
                              top: '3px',
                              marginRight: '0',
                              marginTop: '0.5em',
                            }}
                            name="hideMortgageCalculator"
                            value={hideMortgageCalculator}
                            onClick={this.handleOnCollapseSegment}
                            disabled={this.state.loading}
                          />
                        </Grid.Row>
                      </Grid>
                    </Header>
                    {
                      !hideMortgageCalculator && this.props.auth && !isForeignCompany(this.props.auth.company) ? (
                        <Segment attached>
                          <MortgageCalculator
                            packagePricings={this.getUnitPackagePricings()}
                            projectCurrencies={data.project.projectCurrency}
                            projectID={data.project.id || ''}
                            spaValue={spaFullNumber(data) || 0}
                            unitID={data.id || ''}
                            token={this.props.token}
                            isMobile={isMobile}
                            unitData={data}
                            userAuth={this.props.auth}
                          />
                        </Segment>
                      ) : null
                    }
                  </Grid.Column>
                </Grid.Row>
              ) : ''
            }
          </Grid.Column>
        </Grid.Row>
        {
        data.projectUnitLayout ? (
          <Grid.Row>
            <Grid.Column>
              <Grid>
                { this.checkUnitSpecificationAccess(editData) ?
                  <Grid.Row>
                    <Grid.Column>
                      <SpecificationTable
                        newHeader={t('Unit Specification').toUpperCase()}
                        isCollapsible
                        type="units"
                        data={editData.specifications}
                        editable={this.hasEditAccess()}
                        loading={this.state.loading}
                        onChange={this.handleSpecificationsChange}
                        onClick={this.handleUpdateUnitLayout}
                        onCancel={this.handleResetUnitLayout}
                        notFoundNode={<p>{t('No specifications set')}.</p>}
                      />
                    </Grid.Column>
                  </Grid.Row>
                  : null
                }
                {
                  data.projectUnitLayout.specifications &&
                  data.projectUnitLayout.specifications.length > 0 ?
                    <Grid.Row>
                      <Grid.Column>
                        <SpecificationTable
                          newHeader={t('Layout information').toUpperCase()}
                          isCollapsible
                          type="unit_layouts"
                          data={data.projectUnitLayout.specifications}
                          loading={this.state.loading}
                          notFoundNode={<p>{t('No information set')}.</p>}
                        />
                      </Grid.Column>
                    </Grid.Row>
                  : null
                }
                {
                  data.projectUnitLayout.documents &&
                  data.projectUnitLayout.documents.length > 0 ?
                    <Grid.Row>
                      <Grid.Column width={16} style={isMobile ? { padding: '0' } : {}}>
                        <Header
                          className="new_title"
                          as="h5"
                          textAlign="center"
                          attached="top"
                        >
                          <Grid>
                            <Grid.Row>
                              <Grid.Column width={16} textAlign="center">
                                {t('Documents').toUpperCase()}
                              </Grid.Column>
                              <Label
                                as="button"
                                attached="top right"
                                icon={hideDocument ? 'angle up' : 'angle down'}
                                className="collapse-button"
                                style={{
                                  position: 'absolute',
                                  right: '0',
                                  top: '3px',
                                  marginRight: '0',
                                  marginTop: '0.5em',
                                }}
                                name="hideDocument"
                                value={hideDocument}
                                onClick={this.handleOnCollapseSegment}
                                disabled={this.state.loading}
                              />
                            </Grid.Row>
                          </Grid>
                        </Header>
                        {
                          !hideDocument ? (
                            <Segment attached>
                              <Grid.Row>
                                <Grid.Column>
                                  <Segment.Group>
                                    {
                                      data.projectUnitLayout.documents.map((file, idx) => (
                                        <Segment key={idx}>
                                          <Grid
                                            columns="equal"
                                            verticalAlign="middle"
                                            as="a"
                                            href={`${config.get('bookApiURL')}/documents/${file.id}/view/${encodeURIComponent(file.name)}.pdf`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            <Grid.Column>
                                              <Icon name="file pdf outline" />
                                              {file.name}
                                              <span className="mobile-hide"> ({fileSize(file.size)})</span>
                                              <small className="large-hide small-hide tablet-hide"><br />{fileSize(file.size)}</small>
                                            </Grid.Column>
                                            <Grid.Column textAlign="right">
                                              <small><Timestamp format="DD/MM/YY hh:mm a" timestamp={file.createdAt} /></small>
                                            </Grid.Column>
                                          </Grid>
                                        </Segment>
                                      ))
                                    }
                                  </Segment.Group>
                                </Grid.Column>
                              </Grid.Row>
                            </Segment>
                          ) : null
                        }
                      </Grid.Column>
                    </Grid.Row>
                  : null
                }
                {
                  data.projectUnitLayout.pictures &&
                  data.projectUnitLayout.pictures.some(p => p.type === 'general' || p.type === 'unit_layout') &&
                  data.projectUnitLayout.pictures.length > 0 ?
                    <Grid.Row>
                      <Grid.Column width={16} style={isMobile ? { padding: '0' } : {}}>
                        <Header
                          className="new_title"
                          as="h5"
                          textAlign="center"
                          attached="top"
                        >
                          <Grid>
                            <Grid.Row>
                              <Grid.Column width={16} textAlign="center">
                                {t('Gallery').toUpperCase()}
                              </Grid.Column>
                              <Label
                                as="button"
                                attached="top right"
                                icon={hideGallery ? 'angle up' : 'angle down'}
                                className="collapse-button"
                                style={{
                                  position: 'absolute',
                                  right: '0',
                                  top: '3px',
                                  marginRight: '0',
                                  marginTop: '0.5em',
                                }}
                                name="hideGallery"
                                value={hideGallery}
                                onClick={this.handleOnCollapseSegment}
                                disabled={this.state.loading}
                              />
                            </Grid.Row>
                          </Grid>
                        </Header>
                        {
                          !hideGallery ? (
                            <Segment attached>
                              <Grid.Row>
                                <Grid.Column>
                                  <GalleryList
                                    pictures={[].concat(data.projectUnitLayout.pictures || [], data.projectUnitLayout.medias || [])}
                                    projectID={this.props.id}
                                    unitLayoutID={data.projectUnitLayoutID}
                                    loading={this.state.loading}
                                    excludeType={['site_plan', 'map']}
                                    tabular={this.state.galleryIsTab}
                                    onViewLarge={this.handleViewLarge}
                                    onChange={this.handleGetPicture}
                                    addPath={`/projects/${this.props.id}/layouts/${data.projectUnitLayoutID}/pictures/`}
                                  />
                                </Grid.Column>
                              </Grid.Row>
                            </Segment>
                          ) : null
                        }
                      </Grid.Column>
                    </Grid.Row> : null
                }
              </Grid>
            </Grid.Column>
          </Grid.Row>
        ) : null
      }
        <DelistReasonModal
          open={this.state.showDelistModal}
          onConfirm={this.handleDelistModalConfirm}
          onCancel={this.handleDelistModalCancel}
          reasons={this.state.delistReasons}
          selectedReason={this.state.selectedDelistReason}
          onReasonChange={this.handleDelistReasonChange}
          loading={this.state.loading}
        />
      </Grid>
    );
  }
}

export default withTranslation(namespaces)(connect(Info.mapStateToProps)(Info));



// WEBPACK FOOTER //
// ./src/containers/Project/Unit/Info.jsx